var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnSweep = function SvgIcnSweep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.607 3.7.994.994-4.004 3.997c.75 1.078.854 2.373.224 3.213L8.397 7.48c.84-.63 2.135-.525 3.213.224L15.607 3.7Zm-9.4 10.395C4.798 12.688 3.937 11.008 3.7 9.44l3.416-1.463 5.208 5.208-1.463 3.416c-1.568-.238-3.248-1.099-4.655-2.506Z",
    fill: "#292525"
  })));
};
export default SvgIcnSweep;